'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _homeComponent = require('./home/component');

var _homeComponent2 = _interopRequireDefault(_homeComponent);

exports.Home = _homeComponent2['default'];

var _finalComponent = require('./final/component');

var _finalComponent2 = _interopRequireDefault(_finalComponent);

exports.Final = _finalComponent2['default'];

var _fixtureComponent = require('./fixture/component');

var _fixtureComponent2 = _interopRequireDefault(_fixtureComponent);

exports.Fixture = _fixtureComponent2['default'];

var _groupComponent = require('./group/component');

var _groupComponent2 = _interopRequireDefault(_groupComponent);

exports.Group = _groupComponent2['default'];

var _teamComponent = require('./team/component');

var _teamComponent2 = _interopRequireDefault(_teamComponent);

exports.Team = _teamComponent2['default'];

var _tournamentComponent = require('./tournament/component');

var _tournamentComponent2 = _interopRequireDefault(_tournamentComponent);

exports.Tournament = _tournamentComponent2['default'];